export enum SolicitationMethods {
    GET_SOLICITATION = 'get_solicitation' as any,
    POST_SOLICITATION = 'post_solicitation_oca_get_ready' as any,
    PATCH_OFFERS = 'patch_solicitation_oca_offer' as any,
    PATCH_ADDRESS = 'patch_solicitation_oca_address' as any,
    PATCH_CONFIRMATION = 'patch_solicitation_confirmation' as any,
    POST_COMPLETE = 'post_solicitation_complete_oca' as any
}
